import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

function TypedText({ text, speed = 16, onDone }) {
  const [shown, setShown] = useState("");
  useEffect(() => {
    let i = 0;
    setShown("");
    const id = setInterval(() => {
      i += 1;
      setShown(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(id);
        onDone && onDone();
      }
    }, speed);
    return () => clearInterval(id);
  }, [text, speed, onDone]);
  return <span>{shown}</span>;
}

const SUGGESTIONS = [
  "اشرح لي الفرق بين التشبيه والاستعارة",
  "أعطني مثالًا بليغًا على الكناية",
  "كيف أبدأ خطابًا قويًا؟",
  "ما هي أهم أدوات الإقناع؟",
];

export default function ChatPage() {
  const [sessionId, setSessionId] = useState(null);
  const [messages, setMessages] = useState([
    {
      role: "ai",
      text: "أهلًا بك! أنا معلّمك في البلاغة العربيّة. اسألني عن أيّ مفهوم بلاغي، أو اطلب مني تقييم نصّ، أو اقتراح صياغة أبلغ. كيف أساعدك اليوم؟",
      typed: true,
    },
  ]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const streamRef = useRef(null);

  useEffect(() => {
    if (streamRef.current) streamRef.current.scrollTop = streamRef.current.scrollHeight;
  }, [messages, busy]);

  const send = async (overrideText) => {
    const text = (overrideText ?? input).trim();
    if (!text || busy) return;
    if (!overrideText) setInput("");
    setMessages((m) => [...m, { role: "user", text, typed: true }]);
    setBusy(true);
    try {
      const res = await api.chatFree({ session_id: sessionId, message: text });
      setSessionId(res.session_id);
      setMessages((m) => [...m, { role: "ai", text: res.reply, typed: false }]);
    } catch (e) {
      setMessages((m) => [
        ...m,
        { role: "ai", text: "تعذّر الاتصال بالمعلّم الذكي الآن. حاول مجدّدًا.", typed: true },
      ]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="shell has-bottom-nav" data-testid="chat-page">
      <div className="page-header">
        <h1>
          تحدّث مع <span className="gold">معلّم بَلاغة</span>
        </h1>
        <p>اسأل، ناقش، واطلب نصيحة بلاغيّة في أيّ وقت. معلّمك الذكي حاضر دائمًا.</p>
      </div>

      <div className="panel chat-page-wrap">
        <div className="chat-stream" ref={streamRef}>
          {messages.map((m, idx) => (
            <div
              key={idx}
              className={`bubble ${m.role}`}
              data-testid={`free-chat-bubble-${m.role}`}
            >
              {m.typed ? (
                <span style={{ whiteSpace: "pre-wrap" }}>{m.text}</span>
              ) : (
                <TypedText
                  text={m.text}
                  onDone={() =>
                    setMessages((prev) =>
                      prev.map((p, i) => (i === idx ? { ...p, typed: true } : p))
                    )
                  }
                />
              )}
            </div>
          ))}
          {busy && (
            <div className="bubble ai">
              <span className="typing"><i /><i /><i /></span>
            </div>
          )}
        </div>

        {messages.length <= 1 && (
          <div className="row" style={{ gap: 6, marginTop: 8, marginBottom: 8 }}>
            {SUGGESTIONS.map((s, i) => (
              <button
                key={i}
                data-testid={`chat-suggestion-${i}`}
                className="btn btn-ghost"
                style={{ fontSize: 12, padding: "8px 12px" }}
                onClick={() => send(s)}
                disabled={busy}
              >
                {s}
              </button>
            ))}
          </div>
        )}

        <div className="chat-input" style={{ marginTop: 8 }}>
          <input
            data-testid="chat-page-input"
            value={input}
            placeholder="اكتب سؤالك أو نصّك هنا..."
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") send(); }}
          />
          <button
            data-testid="chat-page-send-btn"
            className="btn btn-primary"
            onClick={() => send()}
            disabled={busy}
          >
            إرسال
          </button>
        </div>
      </div>
    </div>
  );
}
